import 'globals';

(function($, window, document, PageLoadedQueue) {
    window.PageLoadedQueue.addFunction(function() {
        if ($.prototype.slick) {
            $('.slider__items').slick();
        }
    });
})(jQuery, window, document, window.PageLoadedQueue);
